<template>
    <div class="content-wrapper">
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>
                <router-link class="btn btn-sm" :to="{ name: 'TimezonewiseConfigurationList' }"
                  ><i class="fas fa-chevron-left"></i>
                </router-link>
                Data Center
              </h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'Home' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Data Center</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section class="content">
        <div class="container-fluid">
          <div class="card" id="SNMP">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header py-3">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
              </div>
              <div class="card-body pb-1">
                <div class="row">
                  <div class="col-md-8">

                    <div class="form-group required">
                      <label class="control-label">Timezone</label>
                      <multiselect
                        v-model="value.tz_id"
                        :options="Object.keys(pre.timezones)"
                        :custom-label="(opt) => pre.timezones[opt]"
                        placeholder="Select Timezone"
                        :searchable="true"
                        :multiple="false"
                        id="tz_id"
                        v-bind:class="{ 'has-error': errors.has('tz_id') }"
                        v-validate="'required'"
                        name="tz_id"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('tz_id')">
                        {{ errors.first("tz_id") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Name</label>
                      <input
                        type="text"
                        id="dc_name"
                        name="dc_name"
                        v-model="value.dc_name"
                        v-validate.lazy="{required: true}"
                        class="form-control dc_name"
                        placeholder="Name"
                      />
                      <div class="help text-danger" v-show="errors.has('dc_name')">
                        {{ errors.first("dc_name") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Node Url</label>
                      <input
                        type="text"
                        id="node_url"
                        name="node_url"
                        v-model="value.node_url"
                        v-validate.lazy="{required: true}"
                        class="form-control node_url"
                        placeholder="Node Url"
                      />
                      <div class="help text-danger" v-show="errors.has('node_url')">
                        {{ errors.first("node_url") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Data Center Url</label>
                      <input
                        type="text"
                        id="data_centre"
                        name="data_centre"
                        v-model="value.data_centre"
                        v-validate.lazy="{required: true}"
                        class="form-control data_centre"
                        placeholder="Data Center Url"
                      />
                      <div class="help text-danger" v-show="errors.has('data_centre')">
                        {{ errors.first("data_centre") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Threshold</label>
                      <input
                        type="text"
                        id="threshold"
                        name="threshold"
                        v-model="value.threshold"
                        v-validate.lazy="{required: true}"
                        class="form-control threshold"
                        placeholder="Threshold"
                      />
                      <div class="help text-danger" v-show="errors.has('threshold')">
                        {{ errors.first("threshold") }}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="card-footer pt-0 pb-4">
                <button type="submit" v-if="!is_edit" class="btn">Submit</button>
                <button type="submit" v-if="is_edit" class="btn">Update</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "TimezonewiseConfigurationForm",
  metaInfo: {
    title: "Data Center | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      timezones: {},
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/timezonewise_configurations";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/timezonewise_configurations/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "TimezonewiseConfigurationList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/timezonewise_configurations/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      }

      await this.getTimezones()
        .then((response) => {
          this.pre.timezones = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },

    getTimezones: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("get-timezones")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
      this.$emit("update:layout", MasterLayout);
    }, */
};
</script>
